import { queryOptions } from '@tanstack/react-query'

import { CATEGORY_LIST_KEY } from './category.constants'
import { getCategoryList } from './category.service'

// Tek sorgu — hem liste sayfası hem üretim formu kategori dropdown'ı kullanır.
// Kategoriler nadiren değişir; Bilgilig'e her açılışta gitmemek için staleTime.
export function categoryListQueryOptions() {
  return queryOptions({
    queryKey: CATEGORY_LIST_KEY,
    queryFn: getCategoryList,
    staleTime: 5 * 60 * 1000,
  })
}
